import React from "react";
import { Navigate, Outlet, useRoutes } from "react-router-dom";
import appRoutes from "app/config/routes";
import {
  InstituteGroupPage,
  InstituteListPage,
  SessionWiseInstituteListPage,
  SchooEnquiryPage,
  SchoolProfilePage,
  SingleInstituteViewPage,
} from "app/modules/schools/pages";
import { AuthPage } from "../../modules/auth/pages";
import PrivateRoute from "../PrivateRoute";
import { SchoolDashboardPage } from "app/modules/dashboard/pages";
import Layout from "app/layout";
import { AboutSchoolPage } from "app/modules/schools/pages";
import { UserProfilePage } from "app/modules/userProfile/pages";
import UserHeader from "app/layout/Header/UserHeader";
import ForgotPassword from "app/modules/auth/components/ForgotPassword";
import AuthPrivateRoute from "../PrivateRoute/AuthPrivateRoute";
import Product from "app/modules/product";
import ViewInstituteGroup from "app/modules/schools/pages/InstituteGroup/ViewInstituteGroup";
import Invoice from "../Invoice/Invoice";
import {
  DueFollowUpPage,
  ErpCollectionPage,
  TaxInvoicePage,
} from "app/modules/collection/pages";
import IDCard from "app/modules/studentManagement/idCard/pages";
import CustomIdCardPage from "app/modules/studentManagement/idCard/pages/CustomIdCardPage";
import { OrgErpPage, SchoolErpPage } from "app/modules/accessControl";
import Students from "app/modules/studentManagement/students/Students";
import CustomStaffIdCardPage from "app/modules/studentManagement/idCard/pages/CustomStaffIdCardPage";
import { CourseManagementPage, ViewCoursePage } from "app/modules/courses";
import { TenantListPage } from "app/modules/tenantManagement";
import EkalsutraStaffPage from "app/modules/ekalsutraStaff/EkalsutraStaffPage";
import {
  TextSMSPage,
  WhatsappTemplatePage,
} from "app/modules/schools/pages/Communication";
import PaymentGateway from "app/modules/paymentGateway/index";
import { SchoolUserDetailPage } from "app/modules/schools/pages/SchoolUserManagement";
import { PlansPage, SubscriptionsPage } from "app/modules/subscriptions";

const routes = [
  {
    path: "/",
    element: (
      <Layout>
        <Outlet />
      </Layout>
    ),
    children: [
      {
        path: `/`,
        element: <Navigate to={`/${appRoutes.login}`} />,
      },
      {
        path: appRoutes.aboutInstitute,
        element: (
          <PrivateRoute>
            <AboutSchoolPage />
          </PrivateRoute>
        ),
      },
      {
        path: appRoutes.instituteProfile,
        element: (
          <PrivateRoute>
            <SchoolProfilePage />
          </PrivateRoute>
        ),
      },
      // dashboard
      {
        path: `/${appRoutes.dashboard}`,
        element: (
          <PrivateRoute>
            <SchoolDashboardPage />
          </PrivateRoute>
        ),
      },
      {
        path: `/${appRoutes.schoolUserProfile}`,
        element: (
          <PrivateRoute>
            <SchoolUserDetailPage />
          </PrivateRoute>
        ),
      },
      // product
      {
        path: `/${appRoutes.product}`,
        element: (
          <PrivateRoute>
            <Product />
          </PrivateRoute>
        ),
      },
      // {
      //   path: `/${appRoutes.staffIdCard}`,
      //   element: (
      //     <PrivateRoute>
      //       <StaffIDCardTablePage />
      //     </PrivateRoute>
      //   ),
      // },
      {
        path: `/${appRoutes.customStaffIdCard}`,
        element: (
          <PrivateRoute>
            <CustomStaffIdCardPage />
          </PrivateRoute>
        ),
      },
      // school management
      {
        path: `/${appRoutes.institute}`,
        element: <Outlet />,
        children: [
          {
            path: `/${appRoutes.instituteEnquiry}`,
            element: (
              <PrivateRoute>
                <SchooEnquiryPage />
              </PrivateRoute>
            ),
          },
          {
            path: `/${appRoutes.instituteEnquiry}`,
            element: (
              <PrivateRoute>
                <SchooEnquiryPage />
              </PrivateRoute>
            ),
          },
          {
            path: `/${appRoutes.instituteGroup}`,
            element: (
              <PrivateRoute>
                <InstituteGroupPage />
              </PrivateRoute>
            ),
          },
          {
            path: `/${appRoutes.instituteList}`,
            element: (
              <PrivateRoute>
                <InstituteListPage />
              </PrivateRoute>
            ),
          },
          {
            path: `/${appRoutes.sessionWiseInstituteList}`,
            element: (
              <PrivateRoute>
                <SessionWiseInstituteListPage />
              </PrivateRoute>
            ),
          },
          {
            path: `/${appRoutes.singleInstituteView}`,
            element: (
              <PrivateRoute>
                <SingleInstituteViewPage />
              </PrivateRoute>
            ),
          },

          {
            path: `/${appRoutes.viewInstituteGroup}/:id`,
            element: (
              <PrivateRoute>
                <ViewInstituteGroup />
              </PrivateRoute>
            ),
          },

          // {
          //   path: `/${appRoutes.accessControl}`,
          //   element: (
          //     <PrivateRoute>
          //       <AccessControlPage />
          //     </PrivateRoute>
          //   ),
          // },
        ],
      },
      {
        path: `/${appRoutes.studentManagement}`,
        element: <Outlet />,
        children: [
          {
            path: `/${appRoutes.idCard}`,
            element: (
              <PrivateRoute>
                <IDCard />
              </PrivateRoute>
            ),
          },
          {
            path: `/${appRoutes.students}`,
            element: (
              <PrivateRoute>
                <Students />
              </PrivateRoute>
            ),
          },
          {
            path: `/${appRoutes.customIdCard}/:frameCode?`, // frameCode is optional
            element: (
              <PrivateRoute>
                <CustomIdCardPage />
              </PrivateRoute>
            ),
          },
          {
            path: `/${appRoutes.customStaffIdCard}/:frameCode?`, // frameCode is optional
            element: (
              <PrivateRoute>
                <CustomStaffIdCardPage />
              </PrivateRoute>
            ),
          },
        ],
      },
      // collection
      {
        path: `/${appRoutes.collection}`,
        element: <Outlet />,
        children: [
          {
            path: `/${appRoutes.erpCollection}`,
            element: (
              <PrivateRoute>
                <ErpCollectionPage />
              </PrivateRoute>
            ),
          },
          {
            path: `/${appRoutes.taxInvoice}`,
            element: (
              <PrivateRoute>
                <TaxInvoicePage />
              </PrivateRoute>
            ),
          },
          {
            path: `/${appRoutes.dueFollowUp}`,
            element: (
              <PrivateRoute>
                <DueFollowUpPage />
              </PrivateRoute>
            ),
          }
        ],
      },
      // courses
      {
        path: `/${appRoutes.courses}`,
        element: <Outlet />,
        children: [
          {
            path: `/${appRoutes.courseManagement}`,
            element: (
              <PrivateRoute>
                <CourseManagementPage />
              </PrivateRoute>
            ),
          },
          {
            path: `/${appRoutes.courseManagement}/:id`,
            element: (
              <PrivateRoute>
                <ViewCoursePage />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: `/${appRoutes.invoice}/:invoiceId`,
        element: (
          <PrivateRoute>
            <Invoice />
          </PrivateRoute>
        ),
      },
      // communication
      {
        path: `/${appRoutes.communication}`,
        element: <Outlet />,
        children: [
          {
            path: `/${appRoutes.textSms}`,
            element: (
              <PrivateRoute>
                <TextSMSPage />
              </PrivateRoute>
            ),
          },
          {
            path: `/${appRoutes.whatsAppTemplate}`,
            element: (
              <PrivateRoute>
                <WhatsappTemplatePage />
              </PrivateRoute>
            ),
          },
        ],
      },
      // access control
      {
        path: `/${appRoutes.accessControl}`,
        element: <Outlet />,
        children: [
          {
            path: `/${appRoutes.schoolErp}`,
            element: (
              <PrivateRoute>
                <SchoolErpPage />
              </PrivateRoute>
            ),
          },
          {
            path: `/${appRoutes.orgErp}`,
            element: (
              <PrivateRoute>
                <OrgErpPage />
              </PrivateRoute>
            ),
          },
        ],
      },
      // tenant management
      {
        path: `/${appRoutes.tenantManagement}`,
        element: <Outlet />,
        children: [
          {
            path: `/${appRoutes.tenantList}`,
            element: (
              <PrivateRoute>
                <TenantListPage />
              </PrivateRoute>
            ),
          },
        ],
      },
      // subscriptions management
      {
        path: `/${appRoutes.subscriptions}`,
        element: <Outlet />,
        children: [
          {
            path: `/${appRoutes.plans}`,
            element: (
              <PrivateRoute>
                <PlansPage />
              </PrivateRoute>
            ),
          },
          {
            path: `/${appRoutes.customerSubscriptions}`,
            element: (
              <PrivateRoute>
                <SubscriptionsPage />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: `*`,
        element: <>Not Found</>,
      },

      // ekalsutra staff
      {
        path: `/${appRoutes.ekalsutraStaff}`,
        element: (
          <PrivateRoute>
            <EkalsutraStaffPage />
          </PrivateRoute>
        ),
      },
      // razorpay
      {
        path: `/${appRoutes.paymentGateway}`,
        element: (
          <PrivateRoute>
            <PaymentGateway />
          </PrivateRoute>
        ),
      },
    ],
  },

  {
    path: `/${appRoutes.userProfile}`,
    element: (
      <PrivateRoute>
        <UserHeader />
        <UserProfilePage />
      </PrivateRoute>
    ),
  },
  {
    path: `/${appRoutes.login}`,
    element: (
      <AuthPrivateRoute>
        <AuthPage />
      </AuthPrivateRoute>
    ),
  },
  {
    path: `/${appRoutes.register}`,
    element: (
      <AuthPrivateRoute>
        <AuthPage />
      </AuthPrivateRoute>
    ),
  },
  {
    path: `/${appRoutes.forgotPassword}`,
    element: (
      <AuthPrivateRoute>
        <ForgotPassword />
      </AuthPrivateRoute>
    ),
  },
];

const AppRoutes = () => {
  const appRoutes = useRoutes(routes);
  return appRoutes;
};

export default AppRoutes;
